import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header, Segment } from 'semantic-ui/semantic-ui-imports';
import './index.scss';

function VerificationEmailSentPage() {
  // translation
  const { t } = useTranslation();

  return (
    <div className="verification-email-sent-page">
      <div className="verification-email-sent-page__content">
        <Header
          color="teal"
          className="verification-email-sent-page__content__header"
        >
          {t('verificationEmailPage.header')}
        </Header>
        <Segment>
          <p>{t('verificationEmailPage.emailSent')}</p>
        </Segment>
      </div>
    </div>
  );
}

export default VerificationEmailSentPage;
